import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SweetAlert } from 'C4';

export default class Diploma extends Component {
  constructor(props) {
    super(props);

    this.state = {
      diplomaLoaded: false,
      appId: null,
      userData: {
        firstName: null,
        lastName: null,
      },
      shareButtons: null,
      imageLoaded: null,
      imageStyle: {
        opacity: 0.1,
        transition: 'opacity 500ms',
      },
      image: null,
    };
  }

  componentDidMount() {
    this.init();
  }

  setShareButtons(img, firstName, lastName, appName, appId, clientName) {
    const subject = encodeURIComponent(`${firstName} diploma`);
    // Might need to be moved outside of component
    const buttonData = {
      print: {
        className: 'fb',
        href: `/print/${encodeURIComponent(firstName)}/${encodeURIComponent(lastName)}/${appId}`,
      },
      email: {
        className: 'pt',
        href: `mailto:?subject=Your Specialist Badge&body=I'm excited to let you know that I'm now a certified ${appName} Specialist! I have successfully completed the training module from ${clientName} and am now your expert on planning an amazing vacation to ${appName}. Let me know when you're ready to start planning! ${encodeURIComponent(img)}`,
        icon: 'at',
      },
      download: {
        className: 'pt',
        download: `${subject}.png`,
        href: `https://stack.travpromobile.com/download.php?url=${img}&name=${appName}.png`,
        type: 'download',
      },
    };

    const shareButtons = Object.keys(buttonData).map((key) => {
      const {
        className, icon, href, type, ...rest
      } = buttonData[key];

      return (
        <a
          href={href}
          key={key}
          className={`fancybox-share__button fancybox-${type || 'share'}__button--${className}`}
          {...rest}
          target="_blank"
        >
          <FontAwesomeIcon icon={['far', icon || key]} />
          {i18n.translate(`reportCard.${key}`)}
        </a>
      );
    });

    this.setState({ shareButtons });
  }

  async fetchUserData(fromProps = false) {
    const { appName } = this.props;
    const { appId, firstName, lastName, clientName } = this.props;
    const img = `https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=${appId}&fileType=png`;
    this.setState(
      {
        userData: {
          firstName,
          lastName,
        },
        appId,
        image: img,
      },
      this.setShareButtons(img, firstName, lastName, appName, appId, clientName),
    );
  }

  async init() {
    const { appId, firstName, lastName } = this.props;
    const fromProps = [appId, firstName, lastName].every(val => val !== null);
    await this.fetchUserData(fromProps);
  }

  render() {
    const {
      trigger,
      onClose,
    } = this.props;

    const {
      appId, image, shareButtons, imageStyle,
    } = this.state;

    if (shareButtons) {
      return (
        <SweetAlert
          trigger={appId && trigger}
          {...{
            imageUrl: image,
            imageAlt: 'diploma',
            imageLoad: () => {
              this.setState({ imageStyle: { transition: '250ms', opacity: 1 } });
            },
            imageStyle,
            imageLoadedStyle: { opacity: 1 },
            allowOutsideClick: false,
            html: (
              <div className="wrapper__badges">
                <div className="buttons__diploma">
                  {shareButtons}
                </div>
              </div>
            ),
            confirmButtonText: 'Close',
            width: '150rem',
            onClose,
          }}
        />
      );
    }
    return null;
  }
}

Diploma.propTypes = {
  appId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  onClose: PropTypes.func,
  tierIndex: PropTypes.number,
  trigger: PropTypes.bool,
  appName: PropTypes.string,
  clientName: PropTypes.string,
};

Diploma.defaultProps = {
  appId: null,
  firstName: null,
  lastName: null,
  appName: null,
  onClose: () => { },
  tierIndex: null,
  trigger: false,
  clientName: '',
};
